module.exports = {
    RULE : "rule", /* Reconcilation Suggestion Rule */
    EXCEL_MAPPING : "excel_mapping", /* Excel Mapping */
};